/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'
import { PricingVersion } from './PricingVersion.js'

export const Finance = z.object({
  creditOutstanding: z.string(),
  creditReceived: z.string(),
  hostingAndInfraBillingModel: z.string(),
  paddleCustomerId: z.string(),
  paymentStatus: z.enum(['UNKNOWN', 'CURRENT', 'LATE', 'DELINQUENT', 'IN_NEGOTIATION']),
  pricingVersion: PricingVersion,
  primaryBillingContacts: z.array(z.string())
})

export interface Finance extends z.TypeOf<typeof Finance> {}
